import { combineReducers } from 'redux';
import { makeStatusReducer } from 'common/request/status.reducer';
import { makeEntitiesReducer } from 'common/request/entities.reducer';
import { GET_USER_VACCINATION_WORKFLOW } from './user-vaccination-workflow.actions';

export const userVaccinationWorkflowReducer = combineReducers({
  status: makeStatusReducer(GET_USER_VACCINATION_WORKFLOW),
  entities: makeEntitiesReducer(GET_USER_VACCINATION_WORKFLOW),
});
